// Mobile Shuttle Endpoints
import { FLEXIGO_V3, BASEURL } from './base';

const MOBILE = `${BASEURL}rest/v3/mobile`;
const PERSONNEL = `${FLEXIGO_V3}/personnel`;

export const shuttle = {
  searchTripsByLocation: `${MOBILE}/search-trips-by-location`,
  regions: `${MOBILE}/regions`,
  demand: `${PERSONNEL}/workgroups/demand`,
  cancelDemand: `${PERSONNEL}/workgroups/cancel-demand`,
  multiDemand: `${PERSONNEL}/workgroups/multi-demand`,
  optOut: `${PERSONNEL}/workgroups/opt-out`,
  routeDetail: `${MOBILE}/route-detail`,
  reservations: `${PERSONNEL}/reservations`,
  subscribe: `${PERSONNEL}/subscribe`,
  unsubscribe: `${PERSONNEL}/unsubscribe`,
  pinnedRoutes: `${MOBILE}/pinned-routes`,
  pinSubscription: `${MOBILE}/pin-subscription`,
  // MyTrips endpoints
  myNextRides: `${FLEXIGO_V3}/personnel/my-next-rides`,
  destinations: `${BASEURL}rest/mobile/destinations`,
  routeDetails: `${FLEXIGO_V3}/mobile/routes/:routeId/details`,
  vehicleLocation: `${BASEURL}rest/mobile/vehicle/latest`,
  vehiclePositions: `${MOBILE}/vehicle/positions`,
  stationEtas: `${MOBILE}/route-instances/:routeInstanceId/station-etas`,
  activeRide: `${FLEXIGO_V3}/personnel/active-ride/:routeInstanceId/:stationId`,
  cancelReservations: `${FLEXIGO_V3}/personnel/cancel-reservations`,
};

export default shuttle;
